import { store } from '@/store';
import QuestionBuilder from './QuestionBuilder';

export default class PowerPreferenceQuestionBuilder extends QuestionBuilder {
    public constructor() {
        super(true, false, true);
    }

    answers() {
        return ['Standard power', 'High Performance'];
    }

    setAnswer(answer: string) {
        if (answer === 'High Performance') {
            store.dispatch('vehicleModule/submitTrims', ['M340i']);
            store.dispatch('vehicleSearchModule/updateFilteredResults');
        } else {
            store.dispatch('vehicleModule/submitTrims', ['M Sport', 'Sport']);
            store.dispatch('vehicleSearchModule/updateFilteredResults');
        }
    }
}
